var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsEvenMoreDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_1120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z",
    fill: "#ECB54F",
    stroke: "#ECB54F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 20.375C15.7557 20.375 16.875 19.2557 16.875 17.875C16.875 16.4943 15.7557 15.375 14.375 15.375C12.9943 15.375 11.875 16.4943 11.875 17.875C11.875 19.2557 12.9943 20.375 14.375 20.375Z",
    fill: "#6C4C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.625 20.375C27.0057 20.375 28.125 19.2557 28.125 17.875C28.125 16.4943 27.0057 15.375 25.625 15.375C24.2443 15.375 23.125 16.4943 23.125 17.875C23.125 19.2557 24.2443 20.375 25.625 20.375Z",
    fill: "#6C4C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.4004C25.3163 26.7816 24.4155 26.2774 23.3721 25.9296C22.3287 25.5818 21.1728 25.4004 20 25.4004C18.8272 25.4004 17.6713 25.5818 16.6279 25.9296C15.5845 26.2774 14.6837 26.7816 14 27.4004",
    stroke: "#6C4C10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8767 13.7162C12.2344 12.1626 13.1825 11.6152 15.2068 11.2162",
    stroke: "#6C4C10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1201 13.7162C27.7624 12.1626 26.8143 11.6152 24.79 11.2162",
    stroke: "#6C4C10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_1120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsEvenMoreDefault);
export default __webpack_public_path__ + "static/media/hurts-even-more-default.6f8e7276c709c468cc6ef5e153f2d76e.svg";
export { ForwardRef as ReactComponent };